import React from 'react';
import {Modal} from './index';
import {getStorage} from '../../utils/storage';
/*
 Displays a modal at the bottom of the screen that can be dismissed for a set amount of time.
 */

// On devices we are having trouble with the cookies not loading after being set until after a page
// reload.  We note the dismissed GroundhogModals here to prevent them from being shown again before a page reload

const dismissedGroundHogs = {};
let pushedNotification = false;

export const GroundhogModal = (props) => {
  const {showDontShowAgain = true, showRemindMeLater = true, cookieName, isOpen} = props;
  const storage = getStorage();
  const now = new Date();
  const storageItem = `GHM-${cookieName}-${window.event_id}`;
  const isHidden =
    cookieName &&
    ((storage &&
      storage.getItem(storageItem) &&
      new Date(parseInt(storage.getItem(storageItem), 10)) > now) ||
      dismissedGroundHogs[cookieName]);

  if (!isHidden && isOpen && !pushedNotification) {
    window.dataLayer.push({event: 'ToastModal'});
    pushedNotification = true;
  }

  const dismissModal = (duration) => {
    if (duration && cookieName && storage) {
      const date = new Date();
      date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1000);
      storage.setItem(storageItem, `${date.getTime()}`);
    }
    if (cookieName) dismissedGroundHogs[cookieName] = true;
    props.hideModal && props.hideModal();
  };

  return (
    <Modal
      isOpen={isOpen && !isHidden}
      onClose={dismissModal}
      onExited={props.onExited}
      className="EviteModal__Content GroundhogModal"
      bodyOpenClassName="ReactModal__Body--open--allow-scroll"
    >
      {props.children}
      {(showDontShowAgain || showRemindMeLater) && (
        <div className="GroundhogModal__controls">
          {showDontShowAgain && (
            <button
              data-qa-id={`ghm-dontshowagain${cookieName ? `-${cookieName}` : ''}`}
              className="GroundhogModal__dontShowAgainButton"
              onClick={() => dismissModal(365)}
            >
              Don't show again
            </button>
          )}
          {showRemindMeLater && (
            <button
              data-qa-id={`ghm-dismiss${cookieName ? `-${cookieName}` : ''}`}
              className="GroundhogModal__remindMeLaterButton"
              onClick={() =>
                dismissModal(
                  evite.features.GHM_TIMEOUT ? parseFloat(evite.features.GHM_TIMEOUT) : 1
                )
              }
            >
              Remind me later
            </button>
          )}
        </div>
      )}
    </Modal>
  );
};
